var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 -0.00012207C0.895431 -0.00012207 0 0.895308 0 1.99988V7.99988C0 9.10445 0.89543 9.99988 2 9.99988L2 8.99988C2 7.89531 2.89543 6.99988 4 6.99988H10C11.1046 6.99988 12 7.89531 12 8.99988V9.99988C13.1046 9.99988 14 9.10445 14 7.99988V1.99988C14 0.895308 13.1046 -0.00012207 12 -0.00012207H2ZM11 9.99988V8.99988C11 8.44759 10.5523 7.99988 10 7.99988H4C3.44772 7.99988 3 8.44759 3 8.99988V9.99988H11ZM9 2.49988C9 2.22374 9.22386 1.99988 9.5 1.99988H11.5C11.7761 1.99988 12 2.22374 12 2.49988C12 2.77602 11.7761 2.99988 11.5 2.99988H9.5C9.22386 2.99988 9 2.77602 9 2.49988Z",
    fill: "#9E9288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipIconGray);
export default __webpack_public_path__ + "static/media/equip-icon-gray.fe207f8916dc48aec34449d1a3af2b54.svg";
export { ForwardRef as ReactComponent };